import { FC } from 'react';
import { Button, Popconfirm } from 'antd';
import FileExportSolid from '../../../assets/icons/file-export-solid.svg';
import styles from './index.module.scss';
import Icon from '../../Icon';

interface IProps {
  onClick: () => void;
}

const SExportButton: FC<IProps> = ({ onClick }) => {
  return (
    <Popconfirm
      title={
        <div className={styles.popconfirmTitle}>
          Listeyi dışarı aktarmayı onaylıyor musunuz?
        </div>
      }
      overlayInnerStyle={{
        width: 150,
        borderColor: '#2b2d42',
        borderWidth: 1,
        borderStyle: 'solid',
      }}
      okText="Onayla"
      cancelText="İptal"
      icon={null}
      color="#FAFAFA"
      okButtonProps={{
        style: {
          backgroundColor: '#2b2d42',
          borderColor: '#2b2d42',
          width: '45%',
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: '#FAFAFA',
          borderColor: '#2b2d42',
          width: '45%',
        },
      }}
      onConfirm={onClick}
    >
      <Button className={styles.container}>
        <Icon source={FileExportSolid} />
      </Button>
    </Popconfirm>
  );
};

export default SExportButton;
